import { render, staticRenderFns } from "./ListadoObjetivosRelacionados.vue?vue&type=template&id=e46c175c&scoped=true"
import script from "./ListadoObjetivosRelacionados.vue?vue&type=script&lang=js"
export * from "./ListadoObjetivosRelacionados.vue?vue&type=script&lang=js"
import style0 from "./ListadoObjetivosRelacionados.vue?vue&type=style&index=0&id=e46c175c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46c175c",
  null
  
)

export default component.exports